<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "Security-page" },
    [
      _c("div", { staticClass: "mb-1" }, [
        _c("h3", [_vm._v(_vm._s(_vm.$t("security.Security")))]),
      ]),
      _c(
        "div",
        { staticClass: "security-page" },
        [
          _c(
            "b-row",
            { staticClass: "align-items-end" },
            [
              _c("b-col", { attrs: { lg: "8" } }, [
                _c("div", { staticClass: "card-1" }, [
                  _c("div", { staticClass: "title-a" }, [
                    _vm._v(_vm._s(_vm.$t("security.Authenticator-app"))),
                  ]),
                  _c("div", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("security.Security-verification")) +
                        " "
                    ),
                  ]),
                ]),
              ]),
              _c(
                "b-col",
                {
                  staticClass: "d-flex justify-content-end modal-link-btn",
                  attrs: { lg: "4" },
                },
                [
                  _c("div", { staticClass: "mr-2" }, [
                    _vm.user.totpLinked
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "gc-text email-id-min align-items-center",
                          },
                          [
                            _c("GreenCheck", { staticClass: "rc-mr-6" }),
                            _vm._v(" " + _vm._s(_vm.$t("security.Set")) + " "),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          {
                            staticClass:
                              "rc-text email-id-min align-items-center",
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("security.Not-Set")) + " "
                            ),
                          ]
                        ),
                  ]),
                  _vm.user.totpLinked
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-end align-items-center",
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "auto-width",
                              attrs: { variant: "link" },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleEditSetupTOTP(true)
                                },
                              },
                            },
                            [
                              _c("feather-icon", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.v-primary",
                                    modifiers: {
                                      hover: true,
                                      "v-primary": true,
                                    },
                                  },
                                ],
                                staticClass: "f-icon text-primary",
                                staticStyle: { cursor: "pointer" },
                                attrs: {
                                  icon: "EditIcon",
                                  size: "18",
                                  title: _vm.$t("wallet.Edit"),
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "auto-width",
                              attrs: { variant: "link" },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleDeleteSetupTOTP(true)
                                },
                              },
                            },
                            [
                              _c("feather-icon", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.v-primary",
                                    modifiers: {
                                      hover: true,
                                      "v-primary": true,
                                    },
                                  },
                                ],
                                staticClass: "f-icon text-danger",
                                staticStyle: { cursor: "pointer" },
                                attrs: {
                                  icon: "Trash2Icon",
                                  size: "18",
                                  title: _vm.$t("wallet.Delete"),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-modal",
                              rawName: "v-b-modal.modal-link",
                              modifiers: { "modal-link": true },
                            },
                          ],
                          attrs: { variant: "outline-secondary" },
                          on: { click: _vm.setupTOTP },
                        },
                        [_vm._v(_vm._s(_vm.$t("security.Link")))]
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "security-page" },
        [
          _c(
            "b-row",
            { staticClass: "align-items-end" },
            [
              _c("b-col", { attrs: { lg: "8" } }, [
                _c("p", { staticClass: "title-a" }, [
                  _vm._v(_vm._s(_vm.$t("security.Email"))),
                ]),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("security.Login-withdrawal"))),
                ]),
              ]),
              _c(
                "b-col",
                {
                  staticClass: "d-flex justify-content-end modal-link-btn",
                  attrs: { lg: "4" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "text-2 align-items-center email-id-min mr-2",
                    },
                    [
                      _c("GreenCheck", { staticClass: "rc-mr-6" }),
                      _vm._v(" " + _vm._s(_vm.userEmail) + " "),
                    ],
                    1
                  ),
                  _c(
                    "b-button",
                    { attrs: { variant: "outline-secondary", disabled: "" } },
                    [_vm._v(_vm._s(_vm.$t("security.Modify")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-link",
            size: "sm",
            "hide-footer": "",
            centered: "",
            "no-close-on-backdrop": true,
          },
          on: { hide: _vm.removeData },
          model: {
            value: _vm.qrModalVisible,
            callback: function ($$v) {
              _vm.qrModalVisible = $$v
            },
            expression: "qrModalVisible",
          },
        },
        [
          _c("h3", { staticClass: "mb-1 text-center modal-title-top" }, [
            _vm._v(" " + _vm._s(_vm.$t("security.Authenticator-app")) + " "),
          ]),
          _c("div", { staticClass: "modal-scrollable" }, [
            _c("div", { staticClass: "scan-info" }, [
              _c("div", { staticClass: "scan-info-row" }, [
                _c("div", { staticClass: "scan-info-col-1" }),
                _c("div", { staticClass: "scan-info-col-2" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t("security.Google-app-Open")) + " "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "scan-info-row" }, [
                _c("div", { staticClass: "scan-info-col-1" }),
                _c("div", { staticClass: "scan-info-col-2" }, [
                  _vm._v(" " + _vm._s(_vm.$t("security.scan-the-qr")) + " "),
                ]),
              ]),
              _c("div", { staticClass: "scan-info-row" }, [
                _c("div", { staticClass: "scan-info-col-1" }),
                _c("div", { staticClass: "scan-info-col-2" }, [
                  _c("b", [_vm._v(_vm._s(_vm.$t("security.Important")) + ":")]),
                  _vm._v(
                    " " + _vm._s(_vm.$t("security.This-key-phrase")) + " "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "scan-info-row" }, [
                _c("div", { staticClass: "scan-info-col-2" }, [
                  _c("b", { staticClass: "share-padding" }, [
                    _vm._v(_vm._s(_vm.$t("security.Never-share"))),
                  ]),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "d-block text-center mt-1 qr-code-block" },
              [
                _c("VueQRCodeComponent", {
                  staticClass: "mb-0 QR",
                  attrs: {
                    text: this.qrCodeURL,
                    size: 155,
                    "error-level": "L",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "d-flex align-items-center justify-content-center mt-1",
              },
              [
                _c("div", { staticClass: "mr-secretKey" }, [
                  _vm._v(" " + _vm._s(this.secretKey) + " "),
                ]),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover.v-primary",
                        modifiers: { hover: true, "v-primary": true },
                      },
                    ],
                    staticClass: "copy-outer",
                    attrs: { title: _vm.$t("wallet.Copy") },
                    on: {
                      click: function ($event) {
                        return _vm.copyURL(_vm.secretKey)
                      },
                    },
                  },
                  [_c("Copy")],
                  1
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "mt-1" },
              [
                _c(
                  "b-input-group",
                  { staticClass: "input-group-merge" },
                  [
                    _c("b-form-input", {
                      ref: "textInput",
                      attrs: {
                        placeholder: _vm.$t("security.Enter-code"),
                        maxlength: "6",
                      },
                      on: { keypress: _vm.validateKeyPress },
                      model: {
                        value: _vm.codeStr,
                        callback: function ($$v) {
                          _vm.codeStr = $$v
                        },
                        expression: "codeStr",
                      },
                    }),
                  ],
                  1
                ),
                !_vm.isCodeValid
                  ? _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.$t("security.enter-number"))),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "d-block text-center mt-1 mb-1 submit-2-fa" },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "primary",
                    disabled: _vm.submitButtonDisabled,
                  },
                  on: { click: _vm.verifyOTP },
                },
                [_vm._v(_vm._s(_vm.$t("security.Submit")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "edit-totp",
            "hide-footer": "",
            centered: "",
            size: "380",
            "no-close-on-backdrop": true,
          },
          model: {
            value: _vm.editTotp,
            callback: function ($$v) {
              _vm.editTotp = $$v
            },
            expression: "editTotp",
          },
        },
        [
          _c(
            "div",
            { staticClass: "icon-bg edit-bg" },
            [_c("feather-icon", { attrs: { icon: "EditIcon", size: "38" } })],
            1
          ),
          _c("h3", { staticClass: "mb-1 text-center" }, [
            _vm._v(_vm._s(_vm.$t("security.edit-title"))),
          ]),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c("div", { staticClass: "mt-0 text-center" }, [
                  _vm._v(" " + _vm._s(_vm.$t("security.edit-2-fa-desc")) + " "),
                ]),
                _c(
                  "div",
                  { staticClass: "d-block text-center mt-2 mb-1" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "min-120-btn",
                        attrs: { variant: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.update2FA(true)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("security.Continue")))]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "delete-totp",
            "hide-footer": "",
            centered: "",
            size: "380",
            "no-close-on-backdrop": true,
          },
          on: {
            hide: function ($event) {
              return _vm.toggleDeleteSetupTOTP(false)
            },
          },
          model: {
            value: _vm.deleteTotp,
            callback: function ($$v) {
              _vm.deleteTotp = $$v
            },
            expression: "deleteTotp",
          },
        },
        [
          _c(
            "div",
            { staticClass: "icon-bg delete-bg" },
            [_c("feather-icon", { attrs: { icon: "Trash2Icon", size: "38" } })],
            1
          ),
          _c("h3", { staticClass: "mb-1 text-center" }, [
            _vm._v(_vm._s(_vm.$t("security.delete-title"))),
          ]),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c("div", { staticClass: "mt-0" }, [
                  _c("div", { staticClass: "desc-delete" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("security.delete-2-fa-desc1")) + " "
                    ),
                  ]),
                  _c("div", [
                    _vm._v(
                      " " + _vm._s(_vm.$t("security.delete-2-fa-desc2")) + " "
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "d-block text-center mt-2 mb-1" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "min-120-btn",
                        attrs: { variant: "primary" },
                        on: { click: _vm.deleteTOTP },
                      },
                      [_vm._v(_vm._s(_vm.$t("security.Continue")))]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("SecurityVerification", {
        attrs: {
          showVerificationPop: _vm.showVerificationPop,
          submitVerification: _vm.submitVerification,
          onModalHidden: _vm.toggleShowVerificationPop,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/views/security/Security.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import * as vuex from 'vuex';
import assets_rashi_coin_QRcode_svg from '@/assets/rashi-coin/QRcode.svg';
import assets_rashi_coin_copy_svg from '@/assets/rashi-coin/copy.svg';
import assets_rashi_coin_green_check_svg from '@/assets/rashi-coin/green-check.svg';
import assets_rashi_coin_google_svg from '@/assets/rashi-coin/google.svg';
import vue_qrcode_component from 'vue-qrcode-component';
import utils_hideEmail from '@/utils/hideEmail';
import libs_api_api from '@/libs/api/api';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import utils_clipboard from '@/utils/clipboard';
import utils_clipboardpast from '@/utils/clipboardpast';
import layouts_components_SecurityVerification_vue from '@/layouts/components/SecurityVerification.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














export default ({
  render,
  staticRenderFns,
  components: {
    BImg: bootstrapvue["BImg"],
    BModal: bootstrapvue["BModal"],
    BButton: bootstrapvue["BButton"],
    BCard: bootstrapvue["BCard"],
    BAvatar: bootstrapvue["BAvatar"],
    QRcode: assets_rashi_coin_QRcode_svg,
    Copy: assets_rashi_coin_copy_svg,
    GreenCheck: assets_rashi_coin_green_check_svg,
    BFormInput: bootstrapvue["BFormInput"],
    BInputGroup: bootstrapvue["BInputGroup"],
    BInputGroupPrepend: bootstrapvue["BInputGroupPrepend"],
    BInputGroupAppend: bootstrapvue["BInputGroupAppend"],
    BRow: bootstrapvue["BRow"],
    BCol: bootstrapvue["BCol"],
    GoogleIcon: assets_rashi_coin_google_svg,
    VueQRCodeComponent: vue_qrcode_component,
    BInputGroupText: bootstrapvue["BInputGroupText"],
    SecurityVerification: layouts_components_SecurityVerification_vue
  },
  directives: {
    "b-tooltip": bootstrapvue["VBTooltip"]
  },
  data() {
    return {
      userEmail: "",
      qrCodeURL: "",
      secretKey: "",
      codeStr: "",
      qrModalVisible: false,
      isCodeValid: true,
      editTotp: false,
      deleteTotp: false,
      isEdit2FA: false,
      showVerificationPop: false
    };
  },
  computed: {
    ...vuex.mapState("user", ["user"]),
    submitButtonDisabled() {
      return this.codeStr.length != 6;
    }
  },
  watch: {
    user(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getUserEmail(newValue);
      }
    }
  },
  mounted() {
    this.getUserEmail();
    // this.userEmail = hideEmail.apply(this, [`${this.user.email}`]);
  },
  methods: {
    ...vuex.mapMutations("user", ["setUser"]),
    removeData() {
      this.codeStr = "";
      this.closeVerifyOTP();
    },
    toggleEditSetupTOTP(flag) {
      this.editTotp = flag;
    },
    toggleDeleteSetupTOTP(flag) {
      this.deleteTotp = flag;
    },
    deleteSetupTOTPClose() {
      this.deleteTotp = false;
    },
    async deleteTOTP() {
      try {
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "DELETE",
          url: `auth/deleteTOTP`
        }, {}, {
          isLoading: true
        });
        if (res && res.result && res.result.requestStatus === "SUCCESS") {
          this.setUser({
            ...this.user,
            totpLinked: false
          });
          this.toggleDeleteSetupTOTP(false);
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    },
    toggleShowVerificationPop(flag) {
      this.showVerificationPop = flag;
    },
    async submitVerification(code) {
      {
        try {
          const res = await new libs_api_api().api({
            method: "post",
            url: "auth/verifyOTP"
          }, {
            code
          }, {
            isLoading: true
          });
          if (res && res.result && res.result.requestStatus === "SUCCESS") {
            this.toggleShowVerificationPop(false);
            this.closeVerifyOTP(false);
            if (!this.isEdit2FA) {
              this.setUser({
                ...this.user,
                totpLinked: true
              });
              this.$toast({
                component: core_components_toastification_ToastificationContent_vue,
                props: {
                  title: this.$t("security.GoogleTwo-FactorAuthenticationSuccessfully"),
                  icon: "EditIcon",
                  variant: "success"
                }
              });
            } else {
              this.setupTOTP();
            }
          } else if (res && res.error && res.error.message) {
            this.$toast({
              component: core_components_toastification_ToastificationContent_vue,
              props: {
                title: res.error.message,
                icon: "EditIcon",
                variant: "danger"
              }
            });
          }
        } catch (error) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: error,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
        this.isLoading = false;
      }
    },
    update2FA() {
      this.isEdit2FA = true;
      this.toggleEditSetupTOTP(false);
      this.toggleShowVerificationPop(true);
      // this.setupTOTP();
    },
    validateKeyPress(event) {
      const key = event.key;
      if (key === "Enter" && event && event.target.value && event.target.value.length && event.target.value.length === 6) {
        this.submitVerification(event.target.value);
      } else if (!/^\d$/.test(key) && key !== "Backspace") {
        event.preventDefault();
        this.isCodeValid = false;
      } else {
        this.isCodeValid = true;
      }
    },
    closeVerifyOTP() {
      this.qrModalVisible = false;
    },
    async getUserEmail() {
      if (this.user.email && this.user.email.length) {
        this.isEdit2FA = this.user.totpLinked;
        this.userEmail = await utils_hideEmail.apply(this, [`${this.user.email}`]);
      } else {
        this.isEdit2FA = false;
        this.userEmail = "";
      }
    },
    async copyURL(props) {
      await utils_clipboard.apply(this, [`${props}`]);
    },
    async pastText() {
      this.codeStr = await utils_clipboardpast.apply(this, []);
    },
    async setupTOTP() {
      this.qrModalVisible = true;
      try {
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "post",
          url: this.isEdit2FA ? "auth/updateTOTP" : "auth/setupTOTP"
        }, {}, {
          isLoading: true
        });
        if (res && res.secretKey && res.qrCodeURL) {
          this.secretKey = res.secretKey;
          this.qrCodeURL = res.qrCodeURL;
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    },
    async verifyOTP() {
      try {
        const res = await new libs_api_api().api({
          method: "post",
          url: "auth/verifyOTP"
        }, {
          code: this.codeStr
        }, {
          isLoading: true
        });
        if (res && res.result && res.result.requestStatus === "SUCCESS") {
          this.qrModalVisible = false;
          this.setUser({
            ...this.user,
            totpLinked: true
          });
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: this.$t("feedbback.2FAsetup-successful"),
              icon: "EditIcon",
              variant: "success"
            }
          });
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    }
  }
});

//# sourceURL=webpack:///./src/views/security/Security.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style>
.title-a {
  color: var(--text-black-color);
  font-size: 14px;
  font-weight: bold;
}[dir] .title-a {
  margin-bottom: 8px;
}
.rc-text {
  color: #ff4d4f;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
.gc-text {
  color: #8dc540;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
.email-id-min {
  min-height: 38px;
  display: flex;
}
.text-2 {
  color: var(--text-black-color);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
[dir] .security-page {
  border-bottom: 1px solid #f0f0f0;
  padding: 15px 0px;
}
[dir=ltr] .rc-mr-6 {
  margin-right: 6px;
}
[dir=rtl] .rc-mr-6 {
  margin-left: 6px;
}
.modal-link-btn .btn {
  min-width: 90px;
}
[dir] .qr-code-block img {
  margin: 0 auto;
}
[dir] .copy-outer {
  cursor: pointer;
}
[dir] .handle-paste {
  cursor: pointer;
}
[dir=ltr] .handle-paste {
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
}
[dir=rtl] .handle-paste {
  border-bottom-right-radius: 0px;
  border-top-right-radius: 0px;
}
[dir] .scan-info {
  background: rgba(141, 197, 64, 0.12);
  padding: 10px;
}
.scan-info .scan-info-row {
  display: flex;
  align-items: flex-start;
}
[dir] .scan-info .scan-info-row {
  margin-bottom: 3px;
}
.scan-info .scan-info-row .scan-info-col-1 {
  height: 6px;
  width: 6px;
  min-height: 6px;
  min-width: 6px;
  color: #3f475a;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
[dir] .scan-info .scan-info-row .scan-info-col-1 {
  border-radius: 50%;
  background: #8dc540;
  margin-top: 5px;
}
.scan-info .scan-info-row .scan-info-col-2 {
  font-size: 11px;
  color: #8dc540;
}
[dir=ltr] .scan-info .scan-info-row .scan-info-col-2 {
  padding-left: 7px;
}
[dir=rtl] .scan-info .scan-info-row .scan-info-col-2 {
  padding-right: 7px;
}
[dir] .mr-secretKey {
  padding-top: 3px;
}
[dir=ltr] .mr-secretKey {
  margin-right: 10px;
}
[dir=rtl] .mr-secretKey {
  margin-left: 10px;
}
[dir=ltr] .fa-2-text svg {
  margin-right: 6px;
}
[dir=rtl] .fa-2-text svg {
  margin-left: 6px;
}
.modal-title-top {
  font-size: 18px;
}
[dir] .modal-title-top {
  margin-top: -15px;
}
[dir=ltr] .share-padding {
  padding-left: 6px;
}
[dir=rtl] .share-padding {
  padding-right: 6px;
}
.submit-2-fa .btn {
  min-width: 115px;
}
#edit-totp .modal-380,
#delete-totp .modal-380 {
  max-width: 380px;
}
[dir] .desc-delete {
  margin-bottom: 7px;
}
</style>
